export default {
  delContent2: lang.templateByUuid("UID:P_UDHWN_17DD50DE050000BC","删除") /* "删除" */,
  editContent2: lang.templateByUuid("UID:P_UDHWN_17DD50DE050000BD","编辑") /* "编辑" */,
  item: lang.templateByUuid("UID:P_UDHWN_17DD50DE050000BE","条") /* "条" */,
  operationSuccess: lang.templateByUuid("UID:P_UDHWN_17DD50DE050000BF","操作成功") /* "操作成功" */,
  batchContentA: lang.templateByUuid("UID:P_UDHWN_17DD50DE050000C0","是否要对选中的") /* "是否要对选中的" */,
  batchContentB: lang.templateByUuid("UID:P_UDHWN_17DD50DE050000C1","记录执行操作吗？") /* "记录执行操作吗？" */,
  handleBatchClickWarning: lang.templateByUuid("UID:P_UDHWN_17DD50DE050000C2","请选择需要批量操作的条目") /* "请选择需要批量操作的条目" */
};
